'use strict'

require 'optimize-suite' # pwa file - has dependencies to md5 and Cookie.js

{Optimize} = window
{config} = Optimize.suiteData
config.finch = config: Optimize.finchConfig
Optimize.config = config
OptimizeSuite.init config



// WEBPACK FOOTER //
// ./core/frontend/optimizeSuite-v1.coffee